import { render, staticRenderFns } from "./question-tree.vue?vue&type=template&id=1685f79c&scoped=true&"
import script from "./question-tree.vue?vue&type=script&lang=js&"
export * from "./question-tree.vue?vue&type=script&lang=js&"
import style0 from "./question-tree.vue?vue&type=style&index=0&id=1685f79c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1685f79c",
  null
  
)

export default component.exports